export default __webpack_public_path__ + "static/background-b0a88f2b0e7399c86828f248b60df3d9.jpg";